import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d4f44474")

_pushScopeId("data-v-d4f44474")
const _hoisted_1 = { class: "ExpressMultiTariffs" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressMultiTariffs__title" }, "Выберите тариф", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "ExpressMultiTariffs__help" }, " Для получения списка тарифов выберите отправителя и получателя ", -1)
const _hoisted_4 = {
  key: 0,
  class: "ExpressMultiTariffs__state state--loading"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "state--text text--loading" }, "Загрузка списка тарифов...", -1)
const _hoisted_6 = {
  key: 1,
  class: "ExpressMultiTariffs__state state--failed"
}
const _hoisted_7 = { class: "state--text text--failed" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Перезагрузить")
const _hoisted_9 = {
  key: 1,
  class: "ExpressMultiTariffs__list"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Тип: ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Авто")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Пеший или велосипед")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Цена: ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Примерное время доставки: ")
const _hoisted_15 = {
  key: 0,
  class: "ExpressMultiTariffs__red"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Выбрано")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Выбрать")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.loading || _ctx.failed)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_s_loader),
                _hoisted_5
              ]))
            : (_ctx.failed)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.errorText), 1),
                  _createVNode(_component_s_button, {
                    class: "blue",
                    onClick: _ctx.emitReload
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.tariffs.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("p", null, " Дистанция: " + _toDisplayString(_ctx.distance) + " " + _toDisplayString(_ctx.declOfNum(_ctx.distance, ['метр', 'метра', 'метров'])), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tariffs, (tariff, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "list__item",
              key: `ExpressMultiTariff-${i}`
            }, [
              _createVNode("div", null, [
                _createVNode("p", null, [
                  _hoisted_10,
                  _createVNode("b", null, [
                    (tariff.transport === 'CAR')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_11
                        ], 64))
                      : (tariff.transport === 'FOOT')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_12
                          ], 64))
                        : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("p", null, [
                  _hoisted_13,
                  _createVNode("b", null, _toDisplayString(tariff.price) + " тенге", 1)
                ]),
                _createVNode("p", null, [
                  _hoisted_14,
                  _createVNode("b", null, _toDisplayString(tariff.time) + " " + _toDisplayString(_ctx.declOfNum(tariff.time, ['минута', 'минуты', 'минут'])), 1)
                ]),
                (tariff.isFastest)
                  ? (_openBlock(), _createBlock("p", _hoisted_15, "Cрочная"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_s_button, {
                class: "blue",
                disabled: _ctx.disabled || _ctx.selectedTariffId === tariff.id,
                onClick: ($event: any) => (_ctx.emitSelect(tariff))
              }, {
                default: _withId(() => [
                  (_ctx.selectedTariffId === tariff.id)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _hoisted_16
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_17
                      ], 64))
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})